import React from "react";
import "./couponcard.css";

const CouponCard = ({ CourseName, price, expDate, teacherName, height, width, margin, onEdit, onDelete }) => {
  return (
    <div className="couponCard" style={{ height, width, margin }}>
      <div className="left">
        <div className="courseName">{CourseName}</div>
        <div className="details">
          <div className="coupon">COUPON</div>
          <div className="info">
            <div>Valid Till:</div>
            <div>{expDate}</div>
          </div>
        </div>
        <div className="line">
          <div style={{ visibility: "hidden" }}>hello</div>
        </div>
        <div className="name">{teacherName}</div>
        {(onEdit || onDelete) && (
          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            {onEdit && (
              <button
                onClick={onEdit}
                style={{
                  padding: '5px 15px',
                  backgroundColor: '#34aadc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                <i className="fas fa-edit"></i> Edit
              </button>
            )}
            {onDelete && (
              <button
                onClick={onDelete}
                style={{
                  padding: '5px 15px',
                  backgroundColor: '#fe1848',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                <i className="fas fa-trash"></i> Delete
              </button>
            )}
          </div>
        )}
      </div>
      <div className="rightCC">
        <div className="rotate">
          <div className="rightCoupon">COUPON</div>
          <div className="price">
            {price} <span>%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponCard;
